import {
  MemberProductLevelEnum,
  PayChannel,
  PaymentRecord,
} from "@features/api/memberApi";

/** 仅内容区 Props，用于 EdgenModalCreateAble 的 children（无需 isOpen） */
export interface ManageBillingModalContentProps {
  onClose: () => void;
  // 指定视图
  view?: "paymentHistory" | "subscriptionAction";
  // 是否允许返回
  allowBack?: boolean;
  // 取消订阅
  onCancelSubscription?: SubscriptionListProps["onCancel"];
}

// 订阅操作组件Props
export interface SubscriptionActionProps {
  onCancelSubscription: () => void; // 取消订阅回调
  className?: string;
  buttonClassName?: string;
}

/** 订阅列表单条展示项（用于 SubscriptionList） */
export interface SubscriptionListItem {
  /** 订阅状态 */
  status: string;
  /** 订阅ID */
  id: string;
  /** 支付渠道，用于展示名称与取消按钮文案 */
  pay_channel: string;
  /** 计划等级，如 Pro、Expert（部分接口不返回时允许缺省） */
  product_level?: MemberProductLevelEnum;
  /** 下次付款日期展示文案，如 Jan 30, 2025 */
  nextPaymentDate: string;
  /** 是否可取消（可点击取消按钮），否则按钮置灰 */
  canCancel?: boolean;
  /** 订阅管理链接 */
  links?: string;
}

/** 订阅列表组件 Props */
export interface SubscriptionListProps {
  /** 订阅项列表，为空时显示空状态 */
  items?: SubscriptionListItem[];
  onCancel?: (item: SubscriptionListItem) => void;
  onManageSubscription?: (item: SubscriptionListItem) => void;
}

// 付款历史组件Props
export interface PaymentHistoryProps {
  paymentHistory: PaymentRecord[]; // 付款历史记录
  className?: string;
}

export const PayChannelMap = {
  [PayChannel.WALLET]: "Wallet",
  [PayChannel.STRIPE]: "Stripe",
  [PayChannel.APPLE_IAP]: "Apple Pay",
  [PayChannel.GOOGLE_IAP]: "Google Pay",
} as const;
